module.exports = __webpack_public_path__ + "img/ua.daed0f81.png";